export default {"src":"/_next/static/media/hero.59376253.svg","height":642,"width":1020,"blurWidth":0,"blurHeight":0};